import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

import { BaseModule } from 'lib/modules';
import { PROCESSOR_VIEW_ROLES } from 'lib/userHelpers';

// Lazy-loaded page components
const LandingPagePage = lazy(
  () =>
    import(
      /* webpackChunkName: "processor-landing-page" */ 'pages/processor/landing-page'
    ),
);

/**
 * Landing Page Module Implementation
 */
class LandingPageModuleClass extends BaseModule {
  id = 'LANDING_PAGE';
  name = 'Landing Page';
  label = 'Landing Page';
  description = 'Public-facing processor landing page configuration';
  version = '1.0.0';
  /**
   * Creates route objects for the Landing Page module
   * @param ProtectedRoute
   * @param LazyWrapper
   * @param settings
   * @param ModuleProtectedRoute
   */
  createRoutes = (
    ProtectedRoute: any,
    LazyWrapper: any,
    settings?: any,
    ModuleProtectedRoute?: any,
  ): RouteObject[] => {
    const routes: RouteObject[] = [];
    const RouteProtector = ModuleProtectedRoute || ProtectedRoute;

    routes.push({
      path: '/processor/landing-page',
      element: (
        <RouteProtector
          component={LandingPagePage}
          moduleId="LANDING_PAGE"
          allowedUserRoles={PROCESSOR_VIEW_ROLES}
        />
      ),
    });

    return routes;
  };
}

// Export singleton instance
export const LandingPageModule = new LandingPageModuleClass();
